// extracted by mini-css-extract-plugin
export default {"root":"AddConfigurationModal_root__qrhce"};